(function () {
  var park = document.getElementById('PriceRequestFormPark');
  if (!park) return;

  var formHost = park.querySelector('.price-request-form-park__block') || park;
  var PRODUCT_TITLE_FIELD = 'custom#produkttitel';
  var PRODUCT_URL_FIELD = 'custom#produkt-url';
  var HIDE_STYLE_ID = 'price-request-form-hide';
  var HIDE_CSS =
    'div:has(> textarea[name="custom#produkttitel"]),' +
    'div:has(> textarea[name="custom#produkt-url"]),' +
    '[data-price-request-hidden="true"]{' +
    'display:none!important;visibility:hidden!important;height:0!important;max-height:0!important;' +
    'margin:0!important;padding:0!important;overflow:hidden!important;border:0!important;' +
    '}';

  var textareaSetter = Object.getOwnPropertyDescriptor(window.HTMLTextAreaElement.prototype, 'value');
  var watchTimer = null;
  var formObserver = null;
  var isSyncing = false;
  var activeModal = null;

  function visitDeep(root, callback) {
    if (!root || root.nodeType !== 1) return;
    callback(root);
    if (root.shadowRoot) visitDeep(root.shadowRoot, callback);
    var child = root.firstElementChild;
    while (child) {
      visitDeep(child, callback);
      child = child.nextElementSibling;
    }
  }

  function injectHideStyles(root) {
    if (!root || !root.appendChild) return;
    if (root.getElementById && root.getElementById(HIDE_STYLE_ID)) return;
    var style = document.createElement('style');
    style.id = HIDE_STYLE_ID;
    style.textContent = HIDE_CSS;
    root.appendChild(style);
  }

  function injectHideStylesDeep(root) {
    visitDeep(root, function (node) {
      if (node.shadowRoot) injectHideStyles(node.shadowRoot);
    });
    injectStyles(root);
  }

  function injectStyles(root) {
    injectHideStyles(root);
  }

  function findTextareas(root) {
    var results = [];
    var seen = new Set();
    visitDeep(root, function (node) {
      if (!node.querySelectorAll) return;
      node.querySelectorAll('textarea').forEach(function (field) {
        if (seen.has(field)) return;
        seen.add(field);
        results.push(field);
      });
    });
    return results;
  }

  function getProductData(modal) {
    if (!modal) return null;

    var title = modal.getAttribute('data-product-title') || '';
    var url = modal.getAttribute('data-product-url') || '';

    if (!title || !url) {
      var por = modal.closest ? modal.closest('.price-on-request') : null;
      if (por) {
        title = title || por.getAttribute('data-product-title') || '';
        url = url || por.getAttribute('data-product-url') || '';
      }
    }

    if (!title && !url) return null;

    return { title: title, url: url };
  }

  function publishProductData(modal) {
    var productData = getProductData(modal);
    window.__priceRequestProductData = productData;
    return productData;
  }

  function clearProductData() {
    window.__priceRequestProductData = null;
    activeModal = null;
  }

  function setFieldValue(field, value) {
    if (!field || value == null || value === '') return false;

    var strValue = String(value);
    if (field._valueTracker) field._valueTracker.setValue('');

    if (textareaSetter && textareaSetter.set) {
      textareaSetter.set.call(field, strValue);
    } else {
      field.value = strValue;
    }

    field.defaultValue = strValue;
    field.dispatchEvent(new Event('input', { bubbles: true, cancelable: true }));
    field.dispatchEvent(new Event('change', { bubbles: true, cancelable: true }));

    if (typeof InputEvent !== 'undefined') {
      field.dispatchEvent(
        new InputEvent('input', {
          bubbles: true,
          cancelable: true,
          data: strValue,
          inputType: 'insertFromPaste',
        })
      );
    }

    return field.value === strValue;
  }

  function hideFieldContainer(field) {
    var node = field;
    for (var depth = 0; depth < 8; depth += 1) {
      if (!node.parentElement) break;
      node = node.parentElement;
      if (node.matches && node.matches('form')) break;

      var controls = node.querySelectorAll('textarea, input:not([type="hidden"])');
      if (controls.length === 1 && controls[0] === field) {
        node.setAttribute('data-price-request-hidden', 'true');
        node.setAttribute('hidden', '');
        node.setAttribute('aria-hidden', 'true');
        node.style.setProperty('display', 'none', 'important');
        return;
      }
      if (controls.length > 1) break;
    }
  }

  function syncProductFields(modal) {
    if (isSyncing) return;

    var productData = publishProductData(modal);
    if (!productData) return;

    isSyncing = true;

    try {
      injectHideStylesDeep(formHost);

      findTextareas(formHost).forEach(function (field) {
        var name = field.getAttribute('name') || field.name || '';
        if (name === PRODUCT_TITLE_FIELD) {
          hideFieldContainer(field);
          setFieldValue(field, productData.title);
        }
        if (name === PRODUCT_URL_FIELD) {
          hideFieldContainer(field);
          setFieldValue(field, productData.url);
        }
      });
    } finally {
      isSyncing = false;
    }
  }

  function mountFormInModal(modal) {
    var slot = modal.querySelector('[data-form-slot]');
    if (slot && formHost.parentElement !== slot) {
      slot.appendChild(formHost);
    }
  }

  function bindSubmitSync(modal) {
    visitDeep(formHost, function (node) {
      if (!node.matches) return;
      if (!node.matches('form[data-testid="form"], form')) return;
      if (node.dataset.priceRequestSubmitBound === 'true') return;
      node.dataset.priceRequestSubmitBound = 'true';
      node.addEventListener(
        'submit',
        function () {
          publishProductData(modal);
          syncProductFields(modal);
        },
        true
      );
    });

    visitDeep(formHost, function (node) {
      if (!node.matches) return;
      if (!node.matches('[data-testid="btn-form-submit"], [type="submit"], button')) return;
      if (node.dataset.priceRequestSubmitBound === 'true') return;
      if (node.type && node.type !== 'submit' && !node.matches('[data-testid="btn-form-submit"]')) return;
      node.dataset.priceRequestSubmitBound = 'true';
      node.addEventListener(
        'mousedown',
        function () {
          publishProductData(modal);
          syncProductFields(modal);
        },
        true
      );
      node.addEventListener(
        'click',
        function () {
          publishProductData(modal);
          syncProductFields(modal);
        },
        true
      );
    });
  }

  function observeForm(modal) {
    if (formObserver) {
      formObserver.disconnect();
      formObserver = null;
    }

    if (typeof MutationObserver === 'undefined') return;

    var debounceTimer = null;
    formObserver = new MutationObserver(function () {
      if (debounceTimer) return;
      debounceTimer = window.setTimeout(function () {
        debounceTimer = null;
        syncProductFields(modal);
        bindSubmitSync(modal);
      }, 80);
    });

    formObserver.observe(formHost, { childList: true, subtree: true });
  }

  function stopObservingForm() {
    if (formObserver) {
      formObserver.disconnect();
      formObserver = null;
    }
  }

  function startWatching(modal) {
    if (watchTimer) {
      window.clearInterval(watchTimer);
      watchTimer = null;
    }

    activeModal = modal;
    publishProductData(modal);
    mountFormInModal(modal);
    injectHideStylesDeep(formHost);
    syncProductFields(modal);
    bindSubmitSync(modal);
    observeForm(modal);

    var attempts = 0;
    watchTimer = window.setInterval(function () {
      attempts += 1;
      publishProductData(modal);
      syncProductFields(modal);
      bindSubmitSync(modal);
      if (attempts >= 30) {
        window.clearInterval(watchTimer);
        watchTimer = null;
      }
    }, 150);
  }

  function stopWatching() {
    if (watchTimer) {
      window.clearInterval(watchTimer);
      watchTimer = null;
    }
    stopObservingForm();
    clearProductData();
  }

  document.addEventListener(
    'modal:handleAfterShow',
    function (event) {
      var modal = event.target;
      if (!modal.classList.contains('price-request-modal')) return;
      startWatching(modal);
    },
    false
  );

  document.addEventListener(
    'modal:handleAfterHide',
    function (event) {
      if (!event.target.classList.contains('price-request-modal')) return;
      stopWatching();
    },
    false
  );
})();
